import companyReducer from './reducers';

export { default as companyActions } from './actions';
export { default as companySelectors } from './selectors';

export default companyReducer;
